import './language.css'
import iconlanguage from '../../icon/language.png'
import { useState } from 'react'
export default function Language(props) {
    const [showlanguage , setShowlanguage] = useState(false)
    function showinglanguage() {
        if(showlanguage === true){
            setShowlanguage(false)
        }else{
            setShowlanguage(true)
        }
    }
    function seten() {
        props.setLanguage('en')
        setShowlanguage(false)
    }
    function setfa() {
        props.setLanguage('fa')
        setShowlanguage(false)
    }
    return(
        <div className='languagebox'>
            <img src={iconlanguage} onClick={showinglanguage}></img>
            <div className='languageselection' style={{left: showlanguage === true ? '0%' : '100%'}}>
            <div><p onClick={seten}>English</p> | <p onClick={setfa}>فارسی</p></div>
            </div>
        </div>
    )
}